



























import {
    defineComponent,
    ref,
    useContext,
    useMeta,
    onBeforeMount
} from '@nuxtjs/composition-api'
import { Components as Guest } from '@/types/client.guest'
import { getVueScript } from '@/composables/promopageOptions'

export default defineComponent({
    layout: 'clear',
    setup: () => {
        const { route, $apiGuest } = useContext()

        const content = ref<Guest.Schemas.ContentPageMinimalModel | null>({
            hideHeader: true,
            hideFooter: true
        })
        const noContent = ref(false)

        useMeta(() => ({
            title: content.value?.name || 'Page Title',
            meta: [
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: String(content.value?.keywords)
                },
                {
                    hid: 'description',
                    name: 'description',
                    content: String(content.value?.description)
                },
                {
                    hid: 'robots',
                    name: !content.value?.noIndex ? 'robots' : '',
                    content: !content.value?.noIndex ? 'noindex' : ''
                },
                {
                    property: 'og:title',
                    content: content.value?.name || 'Page Title'
                },
                {
                    property: 'og:description',
                    content: content.value?.description || ''
                }
            ]
        }))

        const fetchContent = async () => {
            try {
                const { data } = await $apiGuest.contentPagesGetForUser(route.value.params.id)

                content.value = data

                getVueScript(String(content.value.content))
            } catch (error) {
                noContent.value = true
                console.error(error)
            }
        }

        onBeforeMount(async () => {
            await fetchContent()
        })

        return {
            content,
            noContent
        }
    },
    head: {}
})
